import { Component, type ReactNode } from 'react'

interface Props { children: ReactNode; resetKey: string }
interface State { failed: boolean }

export class RouteErrorBoundary extends Component<Props, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State { return { failed: true } }

  componentDidCatch(error: Error) {
    console.error(JSON.stringify({ level: 'error', event: 'route_render_failed', errorType: error.name }))
  }

  componentDidUpdate(previous: Props) {
    if (this.state.failed && previous.resetKey !== this.props.resetKey) this.setState({ failed: false })
  }

  render() {
    if (!this.state.failed) return this.props.children
    return (
      <main role="alert" style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', padding: '4rem 1rem', color: '#f7f7f5', background: '#0a0b0c' }}>
        <div style={{ maxWidth: '34rem', textAlign: 'center' }}>
          <p style={{ color: '#ccff00', fontWeight: 700, letterSpacing: '.12em' }}>TEMPORARY ERROR</p>
          <h1>This page did not load.</h1>
          <p>Your current address is safe. Retry this view or return home.</p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '.75rem' }}>
            <button type="button" onClick={() => this.setState({ failed: false })}>Retry</button>
            <a href="/">Home</a>
          </div>
        </div>
      </main>
    )
  }
}
